export const QA_NAME_WIDGET_HEADER_ADD_BTN = 'widgetHeaderAdd'
